import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Megaphone, ArrowRight } from "lucide-react";
import { useSiteContent } from "../../context/SiteContent";

export const AnnouncementBanner = () => {
  const { content } = useSiteContent();
  const b = content?.announcementBanner;
  if (!b?.isEnabled) return null;

  const go = (link) => {
    if (!link) return;
    if (link.startsWith("#")) {
      const el = document.querySelector(link);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      window.open(link, "_blank", "noopener");
    }
  };

  return (
    <AnimatePresence>
      <motion.div initial={{ height: 0 }} animate={{ height: "auto" }} exit={{ height: 0 }}
        className="fixed top-[68px] inset-x-0 z-40 bg-helios-amber text-helios-slate overflow-hidden"
        data-testid="announcement-banner">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-2.5 flex items-center justify-center gap-3 flex-wrap text-center">
          <Megaphone size={16} className="shrink-0" />
          <span className="text-sm font-medium">{b.message}</span>
          {b.buttonText && (
            <button onClick={() => go(b.buttonLink)}
              className="inline-flex items-center gap-1 rounded-full bg-helios-slate text-white px-3.5 py-1 text-xs font-semibold hover:bg-helios-slate/90 transition-colors"
              data-testid="announcement-cta">
              {b.buttonText} <ArrowRight size={13} />
            </button>
          )}
        </div>
      </motion.div>
    </AnimatePresence>
  );
};
